<template>
  <div>
    <contact-sales-form
      :submit="contactSales"
      :contact="contact"
    />
  </div>
</template>

<script>
import ContactSalesForm from '@/components/Finance/Pricing/ContactSalesForm.vue'
import handleAlerts from '@/compositions/common/handleAlerts'

export default {
  name: 'ContactSales',
  components: { ContactSalesForm },
  data() {
    return {
      contact: {},
    }
  },
  setup() {
    const { successfulOperationAlert } = handleAlerts()
    return { successfulOperationAlert }
  },
  methods: {
    contactSales() {
      return this.$http.axiosIns.post('/organizer/contact-us', { ...this.contact, country: this.contact.country.name }).then(() => {
        this.successfulOperationAlert('The request is submitted successfully')
        this.$router.back()
      })
    },
  },
}
</script>

<style>

</style>
